import { render, staticRenderFns } from "./xieFaYunYong.vue?vue&type=template&id=63c83801&scoped=true&"
import script from "./xieFaYunYong.vue?vue&type=script&lang=js&"
export * from "./xieFaYunYong.vue?vue&type=script&lang=js&"
import style0 from "./xieFaYunYong.vue?vue&type=style&index=0&id=63c83801&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c83801",
  null
  
)

export default component.exports